import { Component, OnDestroy } from '@angular/core';
import { NavController,AlertController,ToastController,ViewController,ModalController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import { provider } from '../../../providers/provider';
import { HttpClient } from '@angular/common/http';
import { Events } from 'ionic-angular';
import { Subject } from 'rxjs';

import { AddAddressPage } from '../addAddress/addAddress';
import { CustomizerProvider } from '../../../providers/customizer/customizer';

@Component({
  selector: 'page-addresses',
  templateUrl: 'addresses.html'
})
export class AddressesPage implements OnDestroy {
  url: string;
  customerInfo = {};
  private _onDestroy = new Subject();
  errore;
  indAggiornato;
  indEliminato;

  constructor(public navCtrl: NavController,
              public translateService: TranslateService,
              public storage: Storage,
              public toastCtrl: ToastController,
              public alertCtrl: AlertController,
              private modalCtrl: ModalController,
              public provider: provider,
              public events: Events,
              public viewCtrl: ViewController,
              public http: HttpClient,
              public customizer: CustomizerProvider) {

    this.translateService.get('MSG_INDIRIZZO').takeUntil(this._onDestroy).subscribe(value => { this.indAggiornato = value });
    this.translateService.get('E9999').takeUntil(this._onDestroy).subscribe(value => { this.errore = value });
    this.translateService.get('MSG_INDIRIZZO_REMOVE').takeUntil(this._onDestroy).subscribe(value => { this.indEliminato = value });
    
    this.url = provider.getUrl();  

    this.storage.get('customer').then((customer) => {
      this.customerInfo = JSON.parse(customer);
    });
    
    // populate customer
    this.retrieveCustomer();
  }

  ngOnDestroy() {
    this._onDestroy.next();
  }

  retrieveCustomer() {
    // get customer from storage
    this.storage.get('customer').then((customer) => {
      this.customerInfo = JSON.parse(customer);
    });
  }

  favorite(favorite) {
    let account = {
      addresses: (<any>this.customerInfo).addresses,
      email: (<any>this.customerInfo).email,
      firstName: (<any>this.customerInfo).firstName,
      lastName: (<any>this.customerInfo).lastName,
      id: (<any>this.customerInfo)._id
    };
    for(let address of (<any>account).addresses) {
      if(address.id == favorite.id) address.favorite = true;
      else address.favorite = false;
    }
    this.provider.edit(account).takeUntil(this._onDestroy).subscribe(() => {
      this.provider.getCustomer(account.id).takeUntil(this._onDestroy).subscribe(data => {
        let toast = this.toastCtrl.create({
          message: this.indAggiornato,
          duration: 3000,
          position: 'middle'
        });
        toast.present();
        this.storage.set('customer', (<any>data)._body);
      }, err => {
        let toast = this.toastCtrl.create({
          message: this.errore,
          duration: 3000,
          position: 'middle'
        });
        toast.present();
      });
    }, err => {
      let toast = this.toastCtrl.create({
        message: this.errore,
        duration: 3000,
        position: 'middle'
      });
      toast.present();
    });
  }

  
  delete(indirizzo) {
    let account = {
      addresses: (<any>this.customerInfo).addresses,
      email: (<any>this.customerInfo).email,
      firstName: (<any>this.customerInfo).firstName,
      lastName: (<any>this.customerInfo).lastName,
      id: (<any>this.customerInfo)._id
    };

    (<any>account).addresses.filter((currentValue, index, arr) => {
      if(currentValue.id == indirizzo.id) {
        if(index == 0) arr.shift();
        else arr.splice(1,index);
      }
    });

    this.provider.edit(account).takeUntil(this._onDestroy).subscribe(() => {
      this.provider.getCustomer(account.id).takeUntil(this._onDestroy).subscribe(data => {
        let toast = this.toastCtrl.create({
          message: this.indEliminato,
          duration: 3000,
          position: 'middle'
        });
        toast.present();
        this.storage.set('customer', (<any>data)._body);
      }, err => {
        let toast = this.toastCtrl.create({
          message: this.errore,
          duration: 3000,
          position: 'middle'
        });
        toast.present();
      });
    }, err => {
      let toast = this.toastCtrl.create({
        message: this.errore,
        duration: 3000,
        position: 'middle'
      });
      toast.present();
    });
  }

  addAddress() {
    let modal = this.modalCtrl.create(AddAddressPage);
    modal.onDidDismiss(() => {
      this.retrieveCustomer();
    });
    modal.present();
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/account/addresses/addresses.ts